import { SVGInterface } from "../../interface";

const Bathtub = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M20 12V5.83C20 4.27 18.73 3 17.17 3C16.42 3 15.7 3.3 15.17 3.83L13.92 5.08C13.76 5.03 13.59 5 13.41 5C13.01 5 12.64 5.12 12.33 5.32L15.09 8.08C15.29 7.77 15.41 7.4 15.41 7C15.41 6.82 15.38 6.66 15.34 6.49L16.59 5.24C16.74 5.09 16.95 5 17.17 5C17.63 5 18 5.37 18 5.83V12C10.1945 12 7.50747 12 2 12V18C2 19.1 2.9 20 4 20C4 20.55 4.45 21 5 21H19C19.55 21 20 20.55 20 20C21.1 20 22 19.1 22 18V12H20ZM20 18H4V14H20V18Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Bathtub;
